import { API_PREFIX } from './constant'
import { Request } from './request'
import {purchaseBusinessExportExcelAsync} from "../features/chainTransferApplication/chainSlice";

export interface ChainInventoryReceiptsParams {
  current?: number
  size?: number
  recepitsDateStart?: string
  recepitsDateEnd?: string
  putNumber?: number
  supplierName?:any
  branchId?:any
  storehouseId?:any
  departmentId?:any
  userId?:any
  storehouseTag?:any
}

export function getChainInventoryList(
  params: ChainInventoryReceiptsParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/page`,
    method: 'GET',
    params,
  }
}

// 调拨出库导出
export function getExportExcelDBCK(params: ChainInventoryReceiptsParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

export function getExportExcel(tenantInventoryReceiptsId?: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceiptsItem/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params: { tenantInventoryReceiptsId },
  }
}
export function getPurchaseBusinessList(
  params: ChainInventoryReceiptsParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/page`,
    method: 'GET',
    params,
  }
}

export function getReturnPage(params: ChainInventoryReceiptsParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/page`,
    method: 'GET',
    params,
  }
}

export function getSubmitForReview(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/submitForReview`,
    method: 'GET',
    params: { branchInventoryReceiptId: id },
  }
}

export function getPurchaseBusinessReview(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/submit`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getReturnReviewRejected(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/submitForReview`,
    method: 'GET',
    params: { branchInventoryReceiptId: id },
  }
}

export function getReturnItemPage(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/itemPage`,
    method: 'GET',
    params,
  }
}

export function getReceiptConfirm(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/receipt`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getQueryInbound(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/queryInbound`,
    method: 'GET',
    params: { inventoryReceiptsId: id, type: 0 },
  }
}
export function getReturnDelivery(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/delivery`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function queryInboundOperateInventory(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/queryInboundOperateInventory`,
    method: 'GET',
    params: { inventoryReceiptsId: id, type: 0 },
  }
}

export function getDelivery(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/delivery`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getReturnReceipt(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/receipt`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function queryOutboundOperateInventory(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/queryOutboundOperateInventory`,
    method: 'GET',
    params: { inventoryReceiptsId: id, type: 0 },
  }
}

export interface ReviewRejectedParams {
  rejectReason?: string
  subInventoryReceiptsId?: number
}

export function getReviewRejected(params: ReviewRejectedParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/reviewRejected`,
    method: 'POST',
    body: params,
  }
}

export function getPurchaseBusinessRejected(
  params: ReviewRejectedParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/reviewRejected`,
    method: 'POST',
    body: params,
  }
}

export function queryInboundDFn(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/queryInbound`,
    method: 'GET',
    params,
  }
}

export function getReturnRejected(params: ReviewRejectedParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/reviewRejected`,
    method: 'POST',
    body: params,
  }
}

export function getApproved(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/approved`,
    method: 'POST',
    body: params,
  }
}

export function getPurchaseBusinessApproved(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/approved`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

//验收单
export function getInventoryPurchAseacceptanceList(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/tenantinventoryPurchAseacceptance/itemList`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}
//验收单
export function getInventoryPurchAseacceptanceSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/submit`,
    method: 'POST',
    body: params,
  }
}
//入库单
export function getInventoryPurchAseacceptanceGspSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryreceipts/inventoryReceiptsSubmit`,
    method: 'POST',
    body: params,
  }
}
//入库单
export function getInventoryReceiptsSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/inventoryReceiptsSubmit`,
    method: 'POST',
    body: params,
  }
}
export function getReturnApproved(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/return/approved`,
    method: 'GET',
    params: { chainInventoryReceiptsId: id },
  }
}

export function getCalcStockByApplyReceipts(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryreceipts/calcStockByApplyReceipts`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getSyncMaterialsCatalog(): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/syncMaterialsCatalog`,
    method: 'GET',
  }
}
export function getPushMaterialsCatalog(): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/pushMaterialsCatalog`,
    method: 'GET',
  }
}

export function purchaseBusinessExportExcel(
  params: ChainInventoryReceiptsParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/pageExcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
export function getSynchrGoods(): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/synchrGoods`,
    method: 'GET',
  }
}
export function postTTickSynchrGoods(ids: number[]): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/tickSynchrGoods`,
    method: 'POST',
    body: ids
  }
}

export function getRemoveAcceptance(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/remove`,
    method: 'POST',
    params: { inventoryPurchaseAcceptanceMainId: id },
  }
}
  
export function getRemoveAcceptanceItem(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/tenantinventoryPurchAseacceptance/remove`,
    method: 'POST',
    params: { inventoryPurchaseAcceptanceId: id },
  }
}

export function getRemoveReceipts(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/remove`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getPurchaseBusinessRemove(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/remove`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getPurchaseBusinessWithdraw(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/purchaseBusiness/withdraw`,
    method: 'GET',
    params: { inventoryReceiptsId: id },
  }
}

export function getInventorypurchaseacceptancemainWithdraw(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/withdraw`,
    method: 'GET',
    params: { id: id },
  }
}


export function getInsertInptPo(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/insertInptPo`,
    method: 'GET',
    params: { inventoryReceiptsId: id, type: 0 },
  }
}

export function insertInptPkt(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/pharmacywareHouse/insertInptPkt`,
    method: 'GET',
    params: { inventoryReceiptsId: id, type: 0 },
  }
}

export function getSelectChainStockOutItem(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryreceipts/selectChainStockOutItem`,
    method: 'GET',
    params,
  }
}

export function getChainList(): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/getChainList`,
    method: 'GET',
  }
}

export function getChainTenantList(): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugquality/getTenantList`,
    method: 'GET',
  }
}


export interface CopyListParams {
  current?: number
  size?: number
  recepitsDateEnd?: string
  recepitsDateStart?: string
  branchId?: number
  putNumber?: any
  storehouseTag?: any
  qurryBranchData?: any
  supplierName?:any
}

export function getCopyList(params: CopyListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/page`,
    method: 'GET',
    params,
  }
}


export interface CopyDetailParams {
  inventoryReceiptsId?:any
  qurryBranchData?: any
}

export function getCopyDetail(params: CopyDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceiptsItem/qurryBranchItemList`,
    method: 'GET',
    params,
  }
}


export interface CopyDetailButtonParams {
  sourceInventoryReceiptsIds?: any
  targetInventoryReceiptsId?:any
  targetInventoryPurchAseacceptanceId?: any
  id?:any
}

export function getCopyDetailButton(body: CopyDetailButtonParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceipts/generateInventoryReceiptsItem`,
    method: 'POST',
    body,
  }
}

export function getCopyDetailAcceptanceButton(body: CopyDetailButtonParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/tenantinventoryPurchAseacceptance/generateinventoryPurchAseacceptance`,
    method: 'POST',
    body,
  }
}

export interface YDExportExcelParams {
  inventoryReceiptsId?: string
  businessType?: any
}

export function getYDExportExcel(params: YDExportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryreceipts/selectChainStockOutItem/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
export interface YDExportExcelFBParams {
  tenantInventoryReceiptsId?: any
}

export function getYDExportExcelFB(params: YDExportExcelFBParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/chainInventoryReceiptsItem/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

export function getExportExcelCGMX(params: YDExportExcelFBParams): Request {
  return {
    url: `${API_PREFIX}/blade-store//inventoryreceiptsitem/purchaseBusiness/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

//验收业务
export function getAcceptancePage(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/page`,
    method: 'GET',
    params,
  }
}

//验收明细
export function getAcceptanceDetailList(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/detailList`,
    method: 'GET',
    params,
  }
}

//验收明细新增
export function getAcceptanceDetailSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/tenantinventoryPurchAseacceptance/submit`,
    method: 'POST',
    body: params,
  }
}

//验收提交
export function getAcceptanceDetailMainSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/acceptanceSubmit`,
    method: 'POST',
    body: params,
  }
}

//验收提交备注
export function getAcceptanceDetailMainRemarkSubmit(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/acceptanceSubmitRemark`,
    method: 'POST',
    body: params,
  }
}

//验收提交备注
export function getAcceptanceApprove(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventorypurchaseacceptancemain/approve`,
    method: 'POST',
    body: params,
  }
}

//生成单据总接口
export function getBuildOtherRecipe(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryreceipts/buildOtherRecipe`,
    method: 'POST',
    body: params,
  }
}


